import type { PlanTypes } from '@gonfalon/billing/types';

import { planIdToPlan } from './planData';

/**
 * Check if a plan is a free developer plan (no payment card required).
 * Currently, only Developer2025 is a free developer plan.
 * Falls back to false if plan is not found or planType is null.
 */
export const isFreeDevPlan = (planType: PlanTypes | null | undefined): boolean => {
  // Return false if planType is not provided
  if (!planType) {
    return false;
  }

  // Find the plan in planData by matching planType
  const plan = Object.values(planIdToPlan).find((p) => p.planType === planType);

  // If plan is found, use its isFreeDevPlan property
  // Otherwise, assume it's not a free dev plan (legacy behavior)
  return plan?.isFreeDevPlan ?? false;
};
